import { Construction } from "lucide-react";

/**
 * A module with no backend, said plainly.
 *
 * These screens shipped from Vibez rendering sample stock levels, purchase
 * orders and aggregator tickets that look exactly like live data. Nothing behind
 * them persists: the numbers are identical on every install and every day. A
 * kitchen manager reading "12 kg paneer, reorder at 5" would act on a figure that
 * came from a fixture file.
 *
 * The design still shows through — the point is to make it obvious that this is a
 * planned screen, not a working one.
 */
export default function ModuleUnavailable({ title, detail, testId }) {
  return (
    <div className="module-unavailable" role="status" data-testid={testId || "module-unavailable"}>
      <Construction />
      <h2>{title}</h2>
      <p>{detail}</p>
    </div>
  );
}
